module.exports = __webpack_public_path__ + "static/media/step6.fb97f61a.svg";